var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../base/classbase.directive';
import { ClassService } from '../../service/class.service';
import { Comp } from '../../models/component/component';
var GridDirective = /** @class */ (function (_super) {
    __extends(GridDirective, _super);
    function GridDirective(el, renderer, service) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        _this.comp = new Comp();
        return _this;
    }
    GridDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    GridDirective.prototype.onInit = function () {
        _super.prototype.setDefClass.call(this, this.key, this.tag + '.' + this.type);
        if (this.type === 'row') {
            if (this.comp.grid && this.comp.grid.row) {
                _super.prototype.addClass.call(this, this.comp.grid.row);
            }
            else {
                _super.prototype.addClass.call(this, '-mx-2');
                _super.prototype.addClass.call(this, '-my-1');
            }
        }
        else if (this.type === 'col') {
            if (this.comp.grid && this.comp.grid.col) {
                _super.prototype.addClass.call(this, this.comp.grid.col);
            }
            else {
                _super.prototype.addClass.call(this, 'col-sm-12');
            }
        }
    };
    GridDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[gridDir]'
                },] }
    ];
    /** @nocollapse */
    GridDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService }
    ]; };
    GridDirective.propDecorators = {
        comp: [{ type: Input }],
        type: [{ type: Input }]
    };
    return GridDirective;
}(ClassBaseDirective));
export { GridDirective };
//# sourceMappingURL=grid.directive.js.map